import { Button, Text } from "react-native-paper";
import Box from "../../Box";

import { isWeb } from "@memorang/helpers/platform";
import { setOpacity } from "@memorang/helpers/setOpacity";
import { useAppTheme } from "../../../useAppTheme";

export type Props = {
	networkErrorMessage: string;
	onPressRetry: () => void;
};

const NetworkErrorMessage = ({ networkErrorMessage, onPressRetry }: Props) => {
	const theme = useAppTheme();
	return (
		<Box
			borderRadius={20}
			borderWidth={1}
			borderColor={setOpacity(theme.colors.error, 0.16)}
			backgroundColor={theme.colors.errorContainer}
			style={{ alignSelf: "flex-start" }}
			gap={8}
			padding={12}
		>
			<Text
				style={{
					...(isWeb
						? {
								wordWrap: "break-word",
							}
						: {}),
					color: theme.colors.onErrorContainer,
				}}
			>
				{networkErrorMessage}
			</Text>

			<Button
				style={{ alignSelf: "flex-start", backgroundColor: theme.colors.error }}
				onPress={onPressRetry}
				mode="contained"
				icon="refresh"
			>
				Try again
			</Button>
		</Box>
	);
};

export default NetworkErrorMessage;
